import { useTranslation } from "react-i18next";

export default function BrandSection() {
  const { t } = useTranslation();

  const trustItems = [
    { icon: "ri-list-check-3", label: t("trust1") },
    { icon: "ri-camera-line", label: t("trust2") },
    { icon: "ri-truck-line", label: t("trust3") },
    { icon: "ri-shield-check-line", label: t("trust4") },
    { icon: "ri-refresh-line", label: t("trust5") },
  ];

  return (
    <section className="py-16 md:py-24 bg-foreground-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <p className="text-foreground-500 text-sm font-medium mb-6 font-heading italic">
          {t("brand_subtitle")}
        </p>
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-6">
          <span className="block">{t("brand_title1")}</span>
          <span className="block">{t("brand_title2")}</span>
          <span className="block">{t("brand_title3")}</span>
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8 mb-14">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-6 py-3 bg-white text-foreground-900 font-semibold rounded-full text-sm hover:bg-foreground-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("brand_cta1")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-6 py-3 border border-white/30 text-white font-medium rounded-full text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("brand_cta2")}
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {trustItems.map((item) => (
            <div
              key={item.label}
              className="bg-foreground-900 rounded-xl p-4 md:p-5 border border-foreground-800/50 flex flex-col items-center gap-2 transition-colors hover:bg-foreground-800/80"
            >
              <i className={`${item.icon} text-primary-400 text-xl w-5 h-5 flex items-center justify-center`}></i>
              <span className="text-white/80 text-xs md:text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}